<template>
    <img
        :src="src"
        :alt="alt"
    />
</template>

<script>
export default {
    name: "BaseImage",
    props: {
        src: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            required: true
        }
    }
}
</script>
